var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityAttributeAssignments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 8.333a4.334 4.334 0 1 1-.002 8.668 4.334 4.334 0 0 1 .002-8.668zm0 .667a3.667 3.667 0 1 0 0 7.335 3.667 3.667 0 0 0 0-7.335zm0 1.333c.184 0 .333.15.333.334v1.666h1.667c.16 0 .295.115.326.266l.007.068c0 .184-.15.333-.333.333H13v1.667a.333.333 0 0 1-.266.326l-.067.007a.333.333 0 0 1-.334-.333V13h-1.666a.333.333 0 0 1-.327-.266l-.007-.067c0-.184.15-.334.334-.334h1.666v-1.666c0-.161.115-.296.266-.327zM5.588 1c.379 0 .725.214.894.553l.632 1.263A.332.332 0 0 0 7.412 3H14a1 1 0 0 1 1 1v2.667a.333.333 0 1 1-.667 0V4A.333.333 0 0 0 14 3.667H7.412a.999.999 0 0 1-.894-.553L5.886 1.85a.332.332 0 0 0-.298-.184H2A.334.334 0 0 0 1.667 2v10c0 .184.149.333.333.333h4.667a.333.333 0 0 1 0 .667H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z",
    fill: "#000",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityAttributeAssignments);
export default __webpack_public_path__ + "static/media/SecurityAttributeAssignments.7e96ca719dedc480334334baa59d54ac.svg";
export { ForwardRef as ReactComponent };